/**
 * Application configuration
 * 
 * Environment variables are provided by Vite at build time.
 * - Local development: Variables from .env.local file (VITE_ prefix)
 * - Deployed environments: Set via Cloudflare Pages environment variables
 */

export const config = {
  /**
   * API base URL for backend requests
   * - Local: http://localhost:8787
   * - Development: https://silent-disco-streaming-dev.aron98.workers.dev
   * - Staging: https://silent-disco-streaming-staging.aron98.workers.dev
   * - Production: https://silent-disco-streaming-prod.aron98.workers.dev
   */
  apiUrl: import.meta.env.VITE_API_URL!,
  
  /**
   * Current environment
   * - local: Local development
   * - development: Development environment
   * - staging: Staging environment
   * - production: Production environment
   */
  environment: import.meta.env.VITE_ENVIRONMENT! as 'local' | 'development' | 'staging' | 'production',
  
  /**
   * Whether the app is running in production
   */
  isProduction: import.meta.env.VITE_ENVIRONMENT === 'production',
  
  /**
   * Whether the app is running in development (local or dev environment)
   */
  isDevelopment: import.meta.env.VITE_ENVIRONMENT === 'local' || import.meta.env.VITE_ENVIRONMENT === 'development',
} as const;
